import React from "react";
import { Col, Row } from "../Grid";

export const MegaMenuCol = ({ ...props }) => <Col sm={12} md={6} {...props} />;
export const MegaMenuRow = ({ ...props }) => <Row {...props} />;
